import { createSelector } from "reselect";
const selectBannerState = createSelector((state) => state.banner, state => state);
const selectBanner = createSelector(selectBannerState, state => state.infos);
export { selectBanner };
